/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { type UseQueryResult } from '@tanstack/react-query';
import { type BatchedReviewStatistics, type ReviewStatisticResponse } from '../interface/types';

export const combineReviewStatisticsBySKU = (
  results: Array<UseQueryResult<ReviewStatisticResponse[], Error>>,
): BatchedReviewStatistics => {
  return results.reduce<BatchedReviewStatistics>(
    (acc, result, index) => {
      acc.rawQueryResults.push(result);

      acc.isPending = acc.isPending || result.isPending;
      acc.isFetching = acc.isFetching || result.isFetching;
      acc.isError = acc.isError || result.isError;

      if (result.data) {
        for (const data of result.data) {
          const skuId = data.skuNumber;

          acc.combinedData[skuId] = data;
          acc.pageInformation[skuId] = index;
        }
      }

      return acc;
    },
    {
      isPending: false,
      isFetching: false,
      isError: false,
      combinedData: {},
      pageInformation: {},
      rawQueryResults: [],
    },
  );
};
